export default __webpack_public_path__ + "static/media/007.ec73e00c.png";